import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Sidebar from './components/Sidebar';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Profile from './pages/Profile';
import Resume from './pages/Resume';
import SavedJobs from './pages/SavedJobs';
import Settings from './pages/Settings';
import LinkedInSearch from './pages/LinkedInSearch';

// Main App component
const App: React.FC = () => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarCollapsed(!isSidebarCollapsed);
  };

  return (
    <Router>
      <AuthProvider>
        <Sidebar isCollapsed={isSidebarCollapsed} toggleSidebar={toggleSidebar}>
          <AppRoutes />
        </Sidebar>
      </AuthProvider>
    </Router>
  );
};

// Component to handle routing
const AppRoutes: React.FC = () => {
  const { currentUser } = useAuth();
  const location = useLocation();

  // If user is not logged in and not on the login page, redirect to login
  // if (!currentUser && location.pathname !== '/login') {
  //   return <Navigate to="/login" state={{ from: location }} replace />;
  // }

  // If user is logged in and on the login page, redirect to dashboard
  // if (currentUser && location.pathname === '/login') {
  //   return <Navigate to="/" replace />;
  // }

  // If user is on the login page, only render the Login component
  // if (location.pathname === '/login') {
  //   return <Login />;
  // }

  // For all other authenticated routes, render the appropriate page
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/" element={<Dashboard />} />
      <Route path="/profile" element={<Profile />} />
      <Route path="/resume" element={<Resume />} />
      <Route path="/saved-jobs" element={<SavedJobs />} />
      <Route path="/settings" element={<Settings />} />
      <Route path="/linkedin-search" element={<LinkedInSearch />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

// Export the App component as default
export default App;
